import { RootState } from "../rootReducer";

export const getLocales = (store: RootState) => store.i18n.locales;
